import { Box } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { WsTypography, WsColors } from 'wisestep-base';

interface ICVParserStatusByWorkspace {
  hour: string;
  type: string;
  columns: GridColDef[];
  rows: Record<string, unknown>[];
}

const CVUploadWithStatus = ({ hour, type, columns, rows }: ICVParserStatusByWorkspace) => {
  const paginationSize = 7;
  const dataToDisplay = rows.map((item) => ({ ...item, id: uuidv4() }));

  return (
    <Box>
      <WsTypography>{`CV's Uploaded in Last ${hour} ${
        type == 'h' ? 'Hours' : 'Days'
      }`}</WsTypography>
      <Box sx={{ height: 516, background: WsColors.White }}>
        <DataGrid
          columns={columns}
          rows={dataToDisplay}
          components={{ Toolbar: GridToolbar }}
          pageSize={paginationSize}
          rowsPerPageOptions={[paginationSize]}
        />
      </Box>
    </Box>
  );
};

export default CVUploadWithStatus;
